import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "scroll-y grid-con full-a",
  id: "customers-details"
}
const _hoisted_2 = { class: "selected-account" }
const _hoisted_3 = { class: "details" }
const _hoisted_4 = { class: "account-info" }
const _hoisted_5 = { class: "contact-info" }
const _hoisted_6 = { class: "name" }
const _hoisted_7 = {
  class: "data",
  type: "text"
}
const _hoisted_8 = { class: "email" }
const _hoisted_9 = {
  class: "data",
  type: "text"
}
const _hoisted_10 = { class: "phone" }
const _hoisted_11 = {
  class: "data",
  type: "text"
}
const _hoisted_12 = { class: "phone" }
const _hoisted_13 = {
  class: "data",
  type: "text"
}
const _hoisted_14 = { class: "discount" }
const _hoisted_15 = { class: "data" }
const _hoisted_16 = { class: "account-activity-container" }
const _hoisted_17 = { class: "dog-list" }
const _hoisted_18 = { class: "contract-list" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "data-value" }
const _hoisted_21 = { class: "data-value" }
const _hoisted_22 = { class: "contract-status" }
const _hoisted_23 = {
  key: 0,
  class: "status green"
}
const _hoisted_24 = {
  key: 1,
  class: "status red"
}
const _hoisted_25 = {
  key: 1,
  class: "contract-detail-null"
}
const _hoisted_26 = {
  key: 0,
  class: "error"
}
const _hoisted_27 = {
  key: 1,
  class: "loading"
}
const _hoisted_28 = { class: "scroll-y" }
const _hoisted_29 = { class: "transaction-container" }
const _hoisted_30 = { class: "inv-data total" }
const _hoisted_31 = { class: "req-val" }
const _hoisted_32 = { class: "inv-data description" }
const _hoisted_33 = { class: "req-val" }
const _hoisted_34 = { class: "inv-data due" }
const _hoisted_35 = { class: "req-val" }
const _hoisted_36 = { class: "inv-data options" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = {
  key: 0,
  class: "transaction-options"
}
const _hoisted_39 = { class: "options-container" }
const _hoisted_40 = {
  class: "transaction-table",
  cellpadding: "0",
  cellspacing: "0",
  border: "0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[10] || (_cache[10] = _createElementVNode("div", { class: "label" }, "Name", -1)),
              _createElementVNode("div", _hoisted_7, _toDisplayString($setup.name), 1)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[11] || (_cache[11] = _createElementVNode("div", { class: "label" }, "Email", -1)),
              _createElementVNode("div", _hoisted_9, _toDisplayString($props.selection?.email || " "), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[12] || (_cache[12] = _createElementVNode("div", { class: "label" }, "Phone", -1)),
              _createElementVNode("div", _hoisted_11, _toDisplayString($props.selection?.phone || " "), 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "label" }, "Postal Code", -1)),
              _createElementVNode("div", _hoisted_13, _toDisplayString($props.selection?.postalCode || " "), 1)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _cache[14] || (_cache[14] = _createElementVNode("div", { class: "label" }, "Discount", -1)),
              _createElementVNode("div", _hoisted_15, _toDisplayString($setup.discountStatus || 'None'), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode($setup["Dropdown"], {
          class: "full-width",
          "is-open": $setup.openDropdown === 'dogs',
          onOpen: _cache[0] || (_cache[0] = ($event: any) => ($setup.openDropdown = 'dogs')),
          onClose: _cache[1] || (_cache[1] = ($event: any) => ($setup.openDropdown = undefined))
        }, {
          header: _withCtx(() => _cache[15] || (_cache[15] = [
            _createTextVNode("Customer Dogs")
          ])),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_17, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.dogs.asArray.filter(d => d.owner === $props.selection.$id), (dog) => {
                return (_openBlock(), _createBlock($setup["DogCard"], {
                  key: dog.$id,
                  dog: dog,
                  onClick: ($event: any) => ($setup.editDog=dog.$id)
                }, null, 8, ["dog", "onClick"]))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["is-open"]),
        _createVNode($setup["Dropdown"], {
          class: "full-width",
          "is-open": $setup.openDropdown === 'notes',
          onOpen: _cache[2] || (_cache[2] = ($event: any) => ($setup.openDropdown = 'notes')),
          onClose: _cache[3] || (_cache[3] = ($event: any) => ($setup.openDropdown = undefined))
        }, {
          header: _withCtx(() => _cache[16] || (_cache[16] = [
            _createTextVNode("Notes")
          ])),
          default: _withCtx(() => [
            _createVNode($setup["UserNotesPanel"], {
              uid: $props.selection.$id
            }, null, 8, ["uid"])
          ]),
          _: 1
        }, 8, ["is-open"]),
        _createVNode($setup["Dropdown"], {
          class: "full-width",
          "is-open": $setup.openDropdown === 'contracts',
          onOpen: _cache[4] || (_cache[4] = ($event: any) => ($setup.openDropdown = 'contracts')),
          onClose: _cache[5] || (_cache[5] = ($event: any) => ($setup.openDropdown = undefined))
        }, {
          header: _withCtx(() => _cache[17] || (_cache[17] = [
            _createTextVNode("Contracts")
          ])),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_18, [
              ($setup.userAgreements.length)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.userAgreements, (agreement) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "contract-detail",
                      key: agreement.$id,
                      onClick: ($event: any) => ($setup.openDocusignEnvelope(agreement.$id, agreement.dsEnvelopeStatus))
                    }, [
                      _cache[19] || (_cache[19] = _createElementVNode("div", { class: "data-key" }, "Name", -1)),
                      _createElementVNode("div", _hoisted_20, _toDisplayString($setup.dogs.dogs[agreement.specifiers?.dogId || '']?.name || "Unknown"), 1),
                      _cache[20] || (_cache[20] = _createElementVNode("div", { class: "data-key" }, "Training", -1)),
                      _createElementVNode("div", _hoisted_21, _toDisplayString($setup.getTrainingType(agreement?.specifiers?.requestId || '')), 1),
                      _createElementVNode("div", _hoisted_22, [
                        _cache[18] || (_cache[18] = _createTextVNode("Contract")),
                        (agreement.dsEnvelopeStatus === 'completed')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, "Signed"))
                          : (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(agreement.dsEnvelopeStatus) + " - " + _toDisplayString(agreement.status), 1))
                      ])
                    ], 8, _hoisted_19))
                  }), 128))
                : _createCommentVNode("", true),
              (!$setup.userAgreements.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, "This user has no user contracts"))
                : _createCommentVNode("", true)
            ]),
            ($setup.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString($setup.error), 1))
              : _createCommentVNode("", true),
            ($setup.loading.type === 'opening-contract')
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, "Opening in new tab..."))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["is-open"]),
        _createVNode($setup["Dropdown"], {
          class: "full-width",
          "is-open": $setup.openDropdown === 'transactions',
          onOpen: _cache[6] || (_cache[6] = ($event: any) => ($setup.openDropdown = 'transactions')),
          onClose: _cache[7] || (_cache[7] = ($event: any) => ($setup.openDropdown = undefined))
        }, {
          header: _withCtx(() => _cache[21] || (_cache[21] = [
            _createTextVNode("Invoices")
          ])),
          default: _withCtx(() => [
            _cache[27] || (_cache[27] = _createElementVNode("h3", { class: "heading" }, null, -1)),
            _createElementVNode("ul", _hoisted_28, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.invoiceStore.asArray, (invoice) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: invoice.invoiceId
                }, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _cache[22] || (_cache[22] = _createElementVNode("div", { class: "label" }, "Amount", -1)),
                      _createElementVNode("div", _hoisted_31, "$ " + _toDisplayString(invoice.totalAmount), 1)
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _cache[23] || (_cache[23] = _createElementVNode("div", { class: "label" }, "Description", -1)),
                      _createElementVNode("div", _hoisted_33, _toDisplayString(invoice.description), 1)
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _cache[24] || (_cache[24] = _createElementVNode("div", { class: "label" }, "Due Date", -1)),
                      _createElementVNode("div", _hoisted_35, _toDisplayString($setup.moment(invoice.dueAt).format("ddd, MM/DD/YY, h:mm a") || "-"), 1)
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("button", {
                        onClick: ($event: any) => ($setup.invOpenSet.has(invoice.$id) ? $setup.invOpenSet.delete(invoice.$id) : $setup.invOpenSet.add(invoice.$id))
                      }, _cache[25] || (_cache[25] = [
                        _createElementVNode("svg", {
                          width: "5",
                          height: "18",
                          viewBox: "0 0 5 18",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg"
                        }, [
                          _createElementVNode("path", {
                            d: "M0 15.6522C0 16.9484 1.11979 18 2.5 18C3.88021 18 5 16.9484 5 15.6522C5 14.356 3.88021 13.3043 2.5 13.3043C1.11979 13.3043 0 14.356 0 15.6522ZM0 9C0 10.2962 1.11979 11.3478 2.5 11.3478C3.88021 11.3478 5 10.2962 5 9C5 7.7038 3.88021 6.65217 2.5 6.65217C1.11979 6.65217 0 7.7038 0 9ZM0 2.34783C0 3.64402 1.11979 4.69565 2.5 4.69565C3.88021 4.69565 5 3.64402 5 2.34783C5 1.05163 3.88021 0 2.5 0C1.11979 0 0 1.05163 0 2.34783Z",
                            fill: "black"
                          })
                        ], -1)
                      ]), 8, _hoisted_37)
                    ]),
                    ($setup.invOpenSet.has(invoice.$id))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                          _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("table", _hoisted_40, [
                              _cache[26] || (_cache[26] = _createElementVNode("thead", null, [
                                _createElementVNode("th", null, "Amount "),
                                _createElementVNode("th", null, "Initiated "),
                                _createElementVNode("th", null, "Est. Arrival "),
                                _createElementVNode("th")
                              ], -1)),
                              _createVNode($setup["InvoiceTransactions"], {
                                "stripe-ids": invoice.stripePaymentIds || []
                              }, null, 8, ["stripe-ids"])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["is-open"])
      ])
    ]),
    ($setup.editDog)
      ? (_openBlock(), _createBlock($setup["Modal"], {
          key: 0,
          onClose: _cache[9] || (_cache[9] = ($event: any) => ($setup.editDog = undefined))
        }, {
          default: _withCtx(() => [
            _createVNode($setup["DogCreator"], {
              "edit-dog": $setup.editDog,
              onClose: _cache[8] || (_cache[8] = ($event: any) => ($setup.editDog = undefined))
            }, null, 8, ["edit-dog"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}